import { render, staticRenderFns } from "./subject-distribute.vue?vue&type=template&id=aa2d4454&scoped=true"
import script from "./subject-distribute.vue?vue&type=script&lang=js"
export * from "./subject-distribute.vue?vue&type=script&lang=js"
import style0 from "./subject-distribute.vue?vue&type=style&index=0&id=aa2d4454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2d4454",
  null
  
)

export default component.exports